import React from 'react';

function Homepage_HowItWorks() {
  return (
    <section className="how-it-works">
      <h2>HOW IT WORKS</h2>
      <div className="steps">
        <div className="step">
          <div className="step-content">
            <img src="/ImageReference/S2_1.png" alt="Select Tier, Subscribe, Get Matched" className="step-icon" />
            <div className="step-text">
              <h3>1. Select Tier, Subscribe, Get Matched</h3>
              <p>Upon subscription, our intelligent matching system will match you with the perfect team for your unique demands.</p>
            </div>
          </div>
        </div>
        <div className="step">
          <div className="step-content">
            <img src="/ImageReference/S3_3.png" alt="Let the Team Take Over" className="step-icon" />
            <div className="step-text">
              <h3>2. Let the Team Take Over</h3>
              <p>Your PM will efficiently assigns your tasks to the right VA. Our team has the right skills and experience to deliver top-notch results.</p>
            </div>
          </div>
        </div>
        <div className="step">
          <div className="step-content">
            <img src="/ImageReference/S2_2.png" alt="Project Manager Assigned to You" className="step-icon" />
            <div className="step-text">
              <h3>3. Project Manager Assigned to You</h3>
              <p>Once subscribed, you'll be invited to join our dedicated Slack workspace. You'll be introduced to your assigned Project Manager for all your communication needs.</p>
            </div>
          </div>
        </div>
        <div className="step">
          <div className="step-content">
            <img src="/ImageReference/S4_4.png" alt="Task Submission" className="step-icon" />
            <div className="step-text">
              <h3>4. Task Submission</h3>
              <p>Sit back and relax as our skilled VA team tackles your task with precision and care. Your Project Manager oversees the entire process to ensure quality and timely delivery.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Homepage_HowItWorks;